// extracted by mini-css-extract-plugin
module.exports = {"sectionTime":"styles_sectionTime__14pJJ","tasks":"styles_tasks__3oFvD","dots":"styles_dots__sKiBd"};